"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowEvent = void 0;
var _react = require("react");
// this hook depends on event name and passed callback fn
// note that passed callback must be memoized via useCallback since it's not defined within useEffect here
const useWindowEvent = (eventName, callback) => {
  (0, _react.useEffect)(() => {
    window.addEventListener(eventName, callback);
    return () => window.removeEventListener(eventName, callback);
  }, [eventName, callback]);
};
exports.useWindowEvent = useWindowEvent;
